import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    location: {
      type: Object,
      required: true,
    },
  },
})
export default class CatalogLocationInfoComponent extends Vue {
  //TODO check if this needs to be deleted
  // scheduleShowing = false;
  // get availableDays() {
  // return this.location.available_days;
  // }

  get phoneAndEmail() {
    const phone = this.location.phone.enabled && this.location.phone.phone;
    const email = this.location.email.enabled && this.location.email.email;

    return [phone, email].filter(tag => tag).join(' - ');
  }
}
